import { Loader2 } from 'lucide-react';

export function LoadingState() {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-6">
      <Loader2 className="w-12 h-12 text-white animate-spin mb-4" />
      <p className="text-[#9595a5]">Loading characters...</p>
    </div>
  );
}
